export default function ProgressBar({ value, max = 100, color = "primary", label, showPct = false }) {
  const pct = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;
  const colorMap = { primary: "bg-primary", success: "bg-emerald-500", warning: "bg-amber-500", danger: "bg-red-500", cyan: "bg-cyan-500" };
  return (
    <div>
      <div className="flex justify-between items-center mb-1">
        {label && <span className="text-xs text-muted">{label}</span>}
        {showPct && <span className="text-xs font-semibold text-ink dark:text-slate-200">{pct}%</span>}
      </div>
      <div className="h-2 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
        <div className={`h-full rounded-full transition-all duration-700 ${colorMap[color] || colorMap.primary}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
